window.TastingGuidesSlider = {
  init: function(section) {
    // Get the slider settings from data attributes
    const slider = section.querySelector('[data-slideshow-classic]');
    const sectionData = JSON.parse(section.querySelector('[data-section-data]').textContent);

    // Define arrow shape for navigation
    const arrowShape = {
      x0: 10,
      x1: 60, y1: 50,
      x2: 65, y2: 45,
      x3: 20
    };

    // Initialize Flickity
    const flickitySlider = new Flickity(slider, {
      wrapAround: true,
      adaptiveHeight: true,
      prevNextButtons: sectionData.show_arrows === 'true',
      pageDots: sectionData.show_nav_buttons === 'true',
      draggable: true,
      imagesLoaded: true,
      fade: sectionData.image_transition === 'slide',
      autoPlay: sectionData.image_slideshow_speed > 0 ? sectionData.image_slideshow_speed * 1000 : false,
      arrowShape: arrowShape
    });

    // Resize flickity when the slider is settled
    slider.addEventListener('settle.flickity', function() {
      flickitySlider.resize();
    });
  }
};

// Initialize all sliders when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.tasting-guides-products__product--slider').forEach(function(section) {
    window.TastingGuidesSlider.init(section);
  });
});
